export default __webpack_public_path__ + "static/media/portfolio.b1f7dfea.png";